import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="py-12 md:py-20 bg-slate-50 border-y border-slate-200" data-id="element-50">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-51">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-white rounded-2xl p-6 md:p-10 shadow-xl border-2 border-green-100 text-center relative overflow-hidden" data-id="element-52">
          <div className="absolute top-0 left-0 w-full h-1.5 bg-green-500" data-id="element-53"></div>
          <div className="w-14 h-14 md:w-20 md:h-20 bg-green-100 text-green-600 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-54">
            <ShieldCheck size={30} className="md:hidden" data-id="element-55" />
            <ShieldCheck size={40} className="hidden md:block" data-id="element-56" />
          </div>
          <h2 className="text-xs font-bold tracking-widest text-green-600 uppercase mb-2" data-id="element-57">
            GARANTÍA
          </h2>
          <h3 className="text-2xl md:text-4xl font-extrabold text-slate-900 mb-4" data-id="element-58">
            🛡️ Garantía 7 días sin riesgo
          </h3>
          <p className="text-base md:text-xl text-slate-600 max-w-2xl mx-auto leading-relaxed" data-id="element-59">
            Estamos tan seguros de la calidad de este material que te ofrecemos
            una garantía total.
            <span className="block mt-3 font-bold text-slate-900" data-id="element-60">
              Si no te convence, te devolvemos el 100% de tu dinero. Sin
              preguntas.
            </span>
          </p>
        </motion.div>
      </div>
    </section>;
}